import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { toNumber } from '../../../../../../../services/helpers';

@Injectable()
export class InvestmentCharacteristicsForm extends AppForm {
  constructor() {
    super({
      investmentNameAndTotalObjects: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      maxBuildingHeight: new FormControl('', { nonNullable: true, validators: [] }),
      width: new FormControl('', { nonNullable: true, validators: [] }),
      thickness: new FormControl('', { nonNullable: true, validators: [] }),
      distance: new FormControl('', { nonNullable: true, validators: [] }),
      area: new FormControl('', { nonNullable: true, validators: [] }),
      height: new FormControl('', { nonNullable: true, validators: [] }),
      groundMountingMethod: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      buildingMaterialsAndColor: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      electricityAccessDescription: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      totalSalesOrUsableArea: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      height: toNumber(this.value.height),
      width: toNumber(this.value.width),
      thickness: toNumber(this.value.thickness),
      area: toNumber(this.value.area),
      distance: toNumber(this.value.distance),
      maxBuildingHeight: toNumber(this.value.maxBuildingHeight),
    };
  }
}
